import { createStore, combineReducers, applyMiddleware } from "redux";
import logger from "redux-logger";
import ReduxThunk from "redux-thunk";
import promise from "redux-promise-middleware";
import authReducer from "./reducers/authReducer";
import partidasReducer from "./reducers/partidasReducer";
import gameReducer from "./reducers/gameReducer";

export default createStore(
  combineReducers({
    authReducer,
    gameReducer,
    partidasReducer
  }),
  {},
  applyMiddleware(logger, ReduxThunk)
);
